<template>
  <div class="dashboard section">
    <h1 class="title">Overfishing</h1>
    <h2 class="subtitle">Dashboard</h2>

    <aside class="menu">
      <ul class="menu-list is-large">
        <li><a v-link="{path:'/leagues'}">Leagues</a></li>
        <li><a v-link="{path:'/people'}">People</a></li>
        <li><a v-link="{path:'/data'}">Data</a></li>
        <p class="menu-label">Presets</p>
        <li><a v-link="{path:'/fish'}">Fish</a></li>
        <li><a v-link="{path:'/countries'}">Countries</a></li>
      </ul>
    </aside>
  </div>
</template>

<script>
  import LeagueAdmin from '../components/LeagueAdmin.vue'
  export default {
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** Dashboard.vue?c623efb6
 **/